import configureStore from './store/configureStore'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { Route, Switch } from 'react-router'
import createHistory from 'history/createBrowserHistory'
import LoginPage from './components/login/LoginPage'
import HomePage from './components/home/HomePage'
import RegisterPage from './components/register/RegisterPage'
import SettingsPage from './components/settings/SettingsPage'

const history = createHistory()

const store = configureStore()

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/register" component={RegisterPage} />
        <Route exact path="/settings" component={SettingsPage} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js